import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

export default function MasterLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false); 
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 850) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };
    handleResize(); 
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar collapsed={collapsed} />
      <div className="flex-1 flex flex-col overflow-y-auto">
        <Header collapsed={collapsed} setCollapsed={setCollapsed} />
        <div className="p-3 flex-1">{children}</div>
      </div>
    </div>
  );
}
